// This function allow to reference async chunks and chunks that the entrypoint depends on
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 792) return "static/chunks/main-efee143d67f03a05.js";
	if (chunkId === 636) return "static/chunks/pages/_app-70aa262c0f27f1b3.js";
	if (chunkId === 593) return "static/chunks/framework-c48e55e26596b9af.js";
	if (chunkId === 880) return "static/chunks/880-83cb363be8a23c43.js";
	if (chunkId === 650) return "static/chunks/650-3454ecc0dd3f43e0.js";
	if (chunkId === 512) return "static/chunks/512-b3d1cddee505bab2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"19":"3957cfd1af1bff14","128":"b92b0fc3c1f930b6","174":"b625a7933b153b18","258":"03b59ffd5ad30682","386":"0b57cca3f0e988fc","406":"6547365f65a0a311","648":"a2ae15a15192c117","719":"b3e07d519225d92e","738":"49dac1e34ba841ae","871":"035dadb28db2dbba","988":"292f3f83868c3a07"}[chunkId] + ".js";
};